import { render, staticRenderFns } from "./CirclesPage.vue?vue&type=template&id=044549a2&scoped=true&"
import script from "./CirclesPage.vue?vue&type=script&lang=js&"
export * from "./CirclesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044549a2",
  null
  
)

export default component.exports